import { useQuery } from "@tanstack/react-query";
import apiRoutes from "../apiRoutes"
import api from "../utils"


export const UseFetchLanguages = () => {
    const getLanguages = async () => {
        const res = await api.post(apiRoutes.fetchLanguages);
        return res.data;
    }

    const { data, ...rest } = useQuery<Languages>({
        queryKey: ['languages'],
        queryFn: getLanguages,
        refetchOnWindowFocus: false,
    })

    return {
        languages: data?.info,
        ...rest
    }
}